import { Link } from "react-router-dom";
import clsx from "clsx";

const base =
  "group relative inline-flex items-center justify-center gap-2 overflow-hidden whitespace-nowrap rounded-full px-6 py-3 text-sm font-bold transition-all duration-300 ease-snap focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-2 focus-visible:ring-offset-2";

const variants = {
  primary:
    "bg-gradient-to-br from-teal to-teal-2 text-white shadow-[0_10px_26px_rgba(15,118,110,0.32)] hover:-translate-y-0.5 hover:shadow-[0_16px_34px_rgba(15,118,110,0.45)]",
  gold:
    "bg-gradient-to-br from-gold to-gold-2 text-amber-950 shadow-gold hover:-translate-y-0.5 hover:shadow-[0_18px_40px_rgba(201,162,39,0.5)]",
  ghost:
    "border-[1.5px] border-line bg-surface text-ink hover:border-teal hover:text-teal-2 dark:hover:border-teal-3 dark:hover:text-teal-3",
};

const sizes = {
  sm: "px-4 py-2 text-[13px]",
  md: "px-6 py-3 text-sm",
  lg: "px-7 py-3.5 text-[15px]",
};

const Button = ({
  as,
  to,
  href,
  variant = "primary",
  size = "md",
  className,
  children,
  ...props
}) => {
  const Component = as || (to ? Link : href ? "a" : "button");
  const extraProps = to ? { to } : href ? { href } : { type: "button" };

  return (
    <Component
      {...extraProps}
      className={clsx(base, variants[variant], sizes[size], className)}
      {...props}
    >
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/35 to-transparent transition-transform duration-700 group-hover:translate-x-full"
      />
      <span className="relative z-10 inline-flex items-center gap-2">
        {children}
      </span>
    </Component>
  );
};

export default Button;